import React, { useContext, useEffect, useState } from 'react';
import { Bounce, toast } from 'react-toastify';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../store/auth-context';
import styles from './ExpenseSetting.module.css';
import { Link } from 'react-router-dom'

const ExpenseSetting = () => {
    const [categories, setCategories] = useState([
        { id: 1, name: 'Office', subcategories: ['Rent', 'Supplies'] },
        { id: 2, name: 'Travel', subcategories: ['Flight', 'Hotel'] }
    ]);
    const authCtx = useContext(AuthContext)
    const [newCategory, setNewCategory] = useState('');
    const [categoryDescription, setCategoryDescription] = useState('')
    const [editId, setEditId] = useState(null);
    const [editCategory, setEditCategory] = useState('');
    const [editSubcategories, setEditSubcategories] = useState('');
    const [standardCategoryData, setStandardCategoryData] = useState([])
    const [activeTab, setActiveTab] = useState('all')

    const fetchStandardExpensesCategoryData = async () => {
        const response = await fetch(BASE_URL_API + "fetchStandardExpensesCategoryData",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setStandardCategoryData(respo.response)
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
        }
    }

    const fetchExpensesCategoryData = async () => {
        const response = await fetch(BASE_URL_API + "fetchExpensesCategoryData",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    categoryName: newCategory,
                    categoryDescription: categoryDescription
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                toast("Successfully Added")

            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
        }
    }

    const handleAddCategory = async (e) => {
        e.preventDefault();
        if (!newCategory.trim()) {
            toast.error('Please fill the category name', {
                position: "top-center",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
            return
        };

        const response = await fetch(BASE_URL_API + "addExpensesCategoryData",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    categoryName: newCategory,
                    categoryDescription: categoryDescription
                })
            })

        if (!response.ok) {

        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                toast("Successfully Added")
                fetchExpensesCategoryData()
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
        }
        console.log(newCategory, categoryDescription)
    };

    const handleDelete = (id) => {
        setCategories(prev => prev.filter(cat => cat.id !== id));
    };

    const startEdit = (cat) => {
        setEditId(cat.id);
    };

    const handleEditSave = () => {

    };

    useEffect(() => {
        fetchStandardExpensesCategoryData()
        fetchExpensesCategoryData()
    }, [])


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer}>
                
                    
                <div className={styles.bodyWrapper}>
                    <div className={styles.contentWrapper}>



                        <form onSubmit={handleAddCategory} className={styles.form}>
                            <input
                                type="text"
                                placeholder="New Category Name"
                                value={newCategory}
                                onChange={(e) => setNewCategory(e.target.value)}
                                className={styles.input}
                            />
                            <input
                                type="text"
                                placeholder="Subcategories (comma separated)"
                                value={categoryDescription}
                                onChange={(e) => setCategoryDescription(e.target.value)}
                                className={styles.input}
                            />
                            <button type="submit" className={styles.button}>Add Category</button>
                        </form>

                        <div className={styles.list}>
                            {categories.map(cat => (
                                <div key={cat.id} className={styles.categoryCard}>
                                    {editId === cat.id ? (
                                        <>
                                            <input
                                                type="text"
                                                value={editCategory}
                                                onChange={(e) => setEditCategory(e.target.value)}
                                                className={styles.input}
                                            />
                                            <input
                                                type="text"
                                                value={editSubcategories}
                                                onChange={(e) => setEditSubcategories(e.target.value)}
                                                className={styles.input}
                                            />
                                            <button onClick={handleEditSave} className={styles.button}>Save</button>
                                            <button onClick={() => setEditId(null)} className={styles.button}>Cancel</button>
                                        </>
                                    ) : (
                                        <>
                                            <div>{cat.name}</div>
                                            <ul className={styles.subList}>
                                                {cat.subcategories.map((sub, idx) => (
                                                    <li key={idx}>{sub}</li>
                                                ))}
                                            </ul>
                                            <div className={styles.actions}>
                                                <button onClick={() => startEdit(cat)} className={styles.button}>Edit</button>
                                                <button onClick={() => handleDelete(cat.id)} className={styles.deleteButton}>Delete</button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpenseSetting;
